<template>
  <div style="padding: 15px" v-if="showFactor">
    <div class="mainClass">
      <div>
        <div class="titleStyle">
          <div>
            صورت حساب های {{ invoiceData.config.title }}
          </div>
          <div id="backButton" style="cursor: pointer" @click="goBack">
            <img src="@/assets/images/back-print-blue.svg" alt="back" />
          </div>
        </div>
        <div class="mt-2">
          <div class="row align-items-center">
            <div class="col-4">
              <div class="imageStyle">
                <img :src="invoiceData.config.image" width="200" alt="logo" />
              </div>
            </div>
            <div class="col-5">
              <div class="d-flex justify-content-center align-items-center">
                <span>فاکتور صورتحساب کالا</span>
              </div>
            </div>
            <div class="col-3">
              <div class="d-flex flex-column justify-content-center align-items-start">
                <div class="d-flex mb-2">
                  <div class="me-2">شماره سند :</div>
                  <div>{{ invoiceData.invoiceNumber }}</div>
                </div>
                <div class="d-flex">
                  <div class="me-2">مورخه :</div>
                  <div>{{ convertJustDate(invoiceData.invoiceDate) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <div class="sectionTitle">مشخصات فروشنده</div>
          <div class="sectionContent">
            <b-row class="rowClass">
              <b-col>
                <div>نام شخص :</div>
                <div>{{ invoiceData.seller.firstName }} {{ invoiceData.seller.lastName }}</div>
              </b-col>
              <b-col>
                <div>شماره اقتصادی :</div>
                <div>{{ invoiceData.seller.economicalNumber }}</div>
              </b-col>
              <b-col>
                <div>شماره ثبت ملی :</div>
                <div>{{ invoiceData.seller.nationalRegistrationNumber }}</div>
              </b-col>
            </b-row>
            <b-row class="rowClass">
              <b-col>
                <div>استان :</div>
                <div>{{ invoiceData.seller.provinceName }}</div>
              </b-col>
              <b-col>
                <div>شهر :</div>
                <div>{{ invoiceData.seller.cityName }}</div>
              </b-col>
              <b-col>
                <div>تلفن :</div>
                <div>{{ invoiceData.seller.mobile }}</div>
              </b-col>
            </b-row>
            <b-row class="rowClass">
              <b-col cols="8">
                <div>آدرس :</div>
                <div>{{ invoiceData.seller.addressText }}</div>
              </b-col>
              <b-col cols="4">
                <div>کد پستی :</div>
                <div>{{ invoiceData.seller.postalCode }}</div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="mt-3">
          <div class="sectionTitle">مشخصات خریدار</div>
          <div class="sectionContent">
            <b-row class="rowClass">
              <b-col>
                <div>نام شخص :</div>
                <div>{{ invoiceData.buyer.firstName }} {{ invoiceData.buyer.lastName }}</div>
              </b-col>
              <b-col>
                <div>شماره اقتصادی :</div>
                <div>{{ invoiceData.buyer.economicalNumber }}</div>
              </b-col>
              <b-col>
                <div>شماره ثبت ملی :</div>
                <div>{{ invoiceData.buyer.nationalRegistrationNumber }}</div>
              </b-col>
            </b-row>
            <b-row class="rowClass">
              <b-col>
                <div>استان :</div>
                <div>{{ invoiceData.buyer.provinceName }}</div>
              </b-col>
              <b-col>
                <div>شهر :</div>
                <div>{{ invoiceData.buyer.cityName }}</div>
              </b-col>
              <b-col>
                <div>تلفن :</div>
                <div>{{ invoiceData.buyer.mobile }}</div>
              </b-col>
            </b-row>
            <b-row class="rowClass">
              <b-col cols="8">
                <div>آدرس :</div>
                <div>{{ invoiceData.buyer.addressText }}</div>
              </b-col>
              <b-col cols="4">
                <div>کد پستی :</div>
                <div>{{ invoiceData.buyer.postalCode }}</div>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="mt-3 tableClass">
          <Table :fields="invoiceData.invoiceItemTableData.fields" :rows="invoiceData.invoiceItemTableData.rows" invoice />
        </div>
        <div class="mt-3">
          <b-row>
            <b-col cols="7">
              {{ invoiceData.note }}
            </b-col>
            <b-col cols="5">
              <div class="receipt-component">
                 <div class="receipt-item-component">
                  <div class="key">هزینه ارسال ( تومان )</div>
                  <div class="value">
                    {{ invoiceData.shippingCost }}
                  </div>
                </div>
                <div class="receipt-item-component">
                  <div class="key">تخفیف کل ( تومان )</div>
                  <div class="value">
                    {{ invoiceData.totalDiscount }}
                  </div>
                </div>

                <div class="receipt-item-component">
                  <div class="key">مالیات کل ( تومان )</div>
                  <div class="value">
                    {{ invoiceData.totalTaxCost }}
                  </div>
                </div>

                <div class="receipt-item-component">
                  <div class="key">مبلغ قابل پرداخت ( تومان )</div>
                  <div class="totalPrice">
                    {{ Commafy(invoiceData.totalPriceAfterDiscountAndTaxAndShippingCost) }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import invoiceDataProvider from '../../../../services/invoice'
import Table from '../../../common/table/Table.vue'
import { numberToWords } from '@persian-tools/persian-tools'

export default {
  components: {
    Table,
  },
  data() {
    return {
      invoiceData: null,
      convertedTotalPrice: null,
      showFactor: false
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: `/list/invoice/detail/${this.$route.params.id}` })
    },
    // popuponclick() {
    //   window.document.write('<body onafterprint="self.close()">')
    // },
  },
  beforeMount() {
    const route = this.$route
    invoiceDataProvider
      .invoicePrint({
        invoiceId: route.params.id,
      })
      .then((res) => {
        this.invoiceData = res.data.data.invoice
        this.convertedTotalPrice = numberToWords(parseInt(res.data.data.invoice.totalPriceAfterDiscountAndTaxAndShippingCost).toFixed(0))
        if (res.status === 200) {
            this.showFactor = true
          setTimeout(() => {
            window.print()
            // this.popuponclick()
          }, 500)
        }
      })
  },
  mounted() {},
  computed: {
    route() {
      return this.$route
    },
  },
  beforeDestroy(){this.showFactor = false}
}
</script>

<style scoped type="text/css" media="print">
header {
  display: none;
}
* {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari, Edge */
  color-adjust: exact !important; /*Firefox*/
}
@page {
  size: landscape;
}
@media print {
  #backButton {
    visibility: hidden;
  }
}
</style>

<style scoped lang="scss">
.kolahduzan-farsi-price {
  padding: 8px;
  border: 1px solid #e8d58e;
  border-radius: 5px;
  height: 55px;
  display: flex;
  align-items: center;
}
.kolahduzan-price {
  padding: 8px;
  background: linear-gradient(89.96deg, #e8d58e 2.34%, #c09a52 100%);
  border-radius: 5px;
  height: 55px;
  display: flex;
  justify-content: space-between;
  color: white;
  align-items: center;
}
.receipt-component {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 10px 20px;
  height: 100%;
}
.receipt-item-component {
  display: flex;
  align-items: center;
  justify-content: space-between;
  letter-spacing: 0px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  .key,
  .value {
    color: #555555;
  }
  .totalPrice {
    font-weight: 700;
    color: #556ee6;
  }
}
.mainClass {
  background: #ffffff;
  width: 100%;
  padding: 20px 100px;
}
.titleStyle {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #444444;
}
::v-deep .tableClass .card {
  margin: 0 !important;
}
::v-deep .tableClass .card-body {
  padding: 0 !important;
}
::v-deep .tableClass .card-body .table {
  margin-bottom: 0 !important;
}
::v-deep .table thead th {
  font-size: 12px;
  padding: 0.5rem;
  line-height: 11px;
}
.description {
  font-size: 12px;
  color: #999999;
}

.rowClass {
  margin-bottom: 7px;
}
::v-deep .col,
.col-4,
.col-8 {
  display: flex;
}
.sectionTitle {
  background: #556ee6;
  width: 100%;
  color: white;
  height: 20px;
  display: flex;
  padding: 14px;
  align-items: center;
}
.sectionContent {
  padding: 5px 10px;
  width: 100%;
  background: #ffffff;
  min-height: 25px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
}
</style>
